export default __webpack_public_path__ + "static/beatbugs-1-d3bb748fe8e83d60108dfc685c6207be.webp";